import ErroneousReadings from 'components/molecules/admin-panel/forms/erroneous-ridings';

import type { FC } from 'react';

interface AdminErroneousActivityProps {
  patientGuid: string;
}

const AdminErroneousActivity: FC<AdminErroneousActivityProps> = ({
  patientGuid,
}) => {
  return <ErroneousReadings patientGuid={patientGuid} />;
};
export default AdminErroneousActivity;
